interface AllowManualSelectionOption {
    name: string;
    value: boolean;
}

export const allowManualSelectionOption: AllowManualSelectionOption[] = [
    {
        name: 'GENERAL.ACTION.YES',
        value: true,
    },
    {
        name: 'GENERAL.ACTION.NO',
        value: false,
    },
];
